import { animate, style, transition, trigger } from "@angular/animations";

export const actionsNavAnimation = trigger("actions-nav", [
  transition(":enter", [
    style({
      transform: "translatex(100%)",
      opacity: 0,
    }),
    animate(
      "250ms ease-in-out",
      style({
        transform: "translatex(0)",
        opacity: 1,
      })
    ),
  ]),
  transition(":leave", [
    animate(
      "250ms ease-in-out",
      style({
        transform: "translatex(100%)",
        opacity: 0,
      })
    ),
  ]),
]);
